<template>
  <div class="electricity px">
    <div class="item">
      <div class="name">
        {{ $t("mouse.name") }}
      </div>
      <div class="battery" :class="{ charging: mouseBatStatus === 1 }">
        <div class="line" v-if="mousePercent === -1"></div>
        <div class="percentage" v-for="i in mouseNum" :key="i"></div>
      </div>
      <i class="iconfont icondian" v-if="mouseBatStatus == 1" />
    </div>
    <div class="item" v-if="$route.path.includes('/dongle-mouse')">
      <div class="name">
        Dongle
      </div>
      <div class="battery" :class="{ charging: mouseDBatStatus === 1 }">
        <div class="line" v-if="mouseDPercent === -1"></div>
        <div class="percentage" v-for="i in mouseDNum" :key="i"></div>
      </div>
      <i class="iconfont icondian" v-if="mouseDBatStatus === 1" />
    </div>
  </div>
</template>
<script>
import { deviceCallbackManager } from "@/utils/DeviceCallbackManager";

const BATTERY_POLL_INTERVAL = 5 * 1000;
const BATTERY_LOADING_POLL_INTERVAL = 1000;
const BATTERY_OFFLINE_RECOVERY_INTERVAL = 2 * 1000;

export default {
  name: "CMouseElectricity",
  data() {
    return {
      mousePercent: 0, // 鼠标电量 范围:0-100
      mouseDPercent: 0, // 鼠标dongle电量 范围:0-100
      mouseBatStatus: 0, // 鼠标电池状态 范围:0未充电 1充电中 2充满
      mouseDBatStatus: 0, // 鼠标dongle电池状态 范围: 0未充电 1充电中 2充满
      mouseOnline: 1, // 鼠标是否在线: 1:在线，0:掉线
      timer: 0,
      offlineRecoveryTimer: 0,
      offlineHandled: false,
      offlineModalRef: null,
      // 非空表示当前有流程暂时接管设备状态，此时暂停电量轮询和离线弹窗。
      // 当前实际来源：
      // - Mouse.vue: import / export
      // - Firmware.vue: firmwarePassword / firmwareUpdate
      // 形态示例：{ import: true, firmwareUpdate: true, firmwarePassword: true }
      pausedGuardSources: {},
    };
  },
  computed: {
    mouseNum() {
      if (this.mousePercent <= 0) {
        return 0;
      } else {
        return Math.ceil(this.mousePercent / 25);
      }
    },
    mouseDNum() {
      if (this.mouseDPercent <= 0) {
        return 0;
      } else {
        return Math.ceil(this.mouseDPercent / 25);
      }
    },
  },
  mounted() {
    this.requestElectricity();
    // 通过 DeviceCallbackManager 订阅电量事件
    deviceCallbackManager.subscribe(
      "updateElectricity",
      this.onHostUpdateElectricity
    );
  },
  beforeDestroy() {
    // 组件销毁时清除定时器，避免退出页面后继续发送获取电量指令
    this.clearPollTimer();
    this.clearOfflineRecoveryTimer();
    this.closeOfflineModal();
    // 取消 DeviceCallbackManager 订阅
    deviceCallbackManager.unsubscribe &&
      deviceCallbackManager.unsubscribe(
        "updateElectricity",
        this.onHostUpdateElectricity
      );
  },
  methods: {
    isBatteryGuardPaused() {
      return Object.keys(this.pausedGuardSources).length > 0;
    },
    pauseBatteryGuard(source = "default") {
      if (this.pausedGuardSources[source]) {
        return;
      }
      this.$set(this.pausedGuardSources, source, true);
      this.clearPollTimer();
    },
    resumeBatteryGuard(source = "default", { refresh = false } = {}) {
      if (this.pausedGuardSources[source]) {
        this.$delete(this.pausedGuardSources, source);
      }
      if (!refresh || this.isBatteryGuardPaused() || this.offlineHandled) {
        return;
      }
      this.requestElectricity();
    },
    clearPollTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    clearOfflineRecoveryTimer() {
      if (this.offlineRecoveryTimer) {
        clearTimeout(this.offlineRecoveryTimer);
        this.offlineRecoveryTimer = null;
      }
    },
    closeOfflineModal() {
      if (this.offlineModalRef?.destroy) {
        this.offlineModalRef.destroy();
        this.offlineModalRef = null;
      }
    },
    scheduleOfflineRecoveryPoll() {
      this.clearOfflineRecoveryTimer();
      if (!this.offlineHandled || this.isBatteryGuardPaused()) {
        return;
      }
      // 只要离线弹窗还在，就每 2 秒补发一次 getElectricity，等宿主回正常包后自动恢复。
      this.offlineRecoveryTimer = setTimeout(() => {
        if (!this.offlineHandled || this.isBatteryGuardPaused()) {
          this.clearOfflineRecoveryTimer();
          return;
        }
        this.$store.dispatch("loader/getElectricity");
        this.scheduleOfflineRecoveryPoll();
      }, BATTERY_OFFLINE_RECOVERY_INTERVAL);
    },
    handleOnlineRecovered() {
      this.offlineHandled = false;
      this.clearOfflineRecoveryTimer();
      this.closeOfflineModal();
    },
    handleOffline() {
      if (this.isBatteryGuardPaused()) {
        return;
      }
      if (this.offlineHandled) {
        return;
      }
      this.offlineHandled = true;
      this.clearPollTimer();
      this.clearOfflineRecoveryTimer();
      this.closeOfflineModal();
      this.offlineModalRef = this.$info({
        title: this.$t("mouse.offline"),
        okText: this.$t("yes"),
        centered: true,
        onOk: () => {
          this.clearOfflineRecoveryTimer();
          this.offlineModalRef = null;
          this.$store.dispatch("loader/setLoading", false);
          this.$router.replace(this.$paths.deviceList);
        },
      });
      this.scheduleOfflineRecoveryPoll();
    },
    requestElectricity() {
      if (this.offlineHandled || this.isBatteryGuardPaused()) {
        return;
      }
      this.clearPollTimer();
      this.$store.dispatch("loader/getElectricity");
    },
    onHostUpdateElectricity(json) {
      if (json) {
        console.log("updateElectricity", json);
        const data = JSON.parse(json);
        let time = BATTERY_POLL_INTERVAL;
        if (!data) {
          return;
        }
        this.mousePercent = data.mousePercent;
        this.mouseDPercent = data.mouseDPercent;
        this.mouseBatStatus = data.mouseBatStatus;
        this.mouseDBatStatus = data.mouseDBatStatus;
        if (this.isBatteryGuardPaused()) {
          return;
        }
        if (data.mouseOnline == 0) {
          this.handleOffline();
          return;
        }
        if (this.offlineHandled) {
          this.handleOnlineRecovered();
        }
        if (data.mouseLoading == 1) {
          time = BATTERY_LOADING_POLL_INTERVAL;
        }
        this.timer = setTimeout(() => {
          this.requestElectricity();
        }, time);
        console.log("updateElectricity", "true");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.electricity.px {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  z-index: 2;
  top: 20px;
  right: 20px;

  .item {
    @include flex-center;
    width: 140px;
    justify-content: flex-start;
    margin-bottom: 5px;

    .name {
      width: 80px;
      text-align: right;
      font-size: 14px;
    }

    .battery {
      @include flex-center;
      justify-content: flex-start;
      width: 31px;
      height: 18px;
      background: url("../../../assets/images/icon_battery.svg") center / 100%
        auto no-repeat;
      position: relative;
      margin: 0 2px 0 8px;
      padding: 3px 0 3px 4px;
      flex: none;

      .percentage {
        height: 10px;
        width: 4px;
        margin-right: 2px;
        border-radius: 1px;
        background-color: $primary-color;
        flex: none;
      }

      &.charging .percentage:last-child {
        animation: chargingChange 2s infinite linear;
      }

      .line {
        height: 150%;
        border-left: 0.03rem solid $primary-color;
        border-right: 0.03rem solid #171717;
        transform: rotate(-30deg);
        position: absolute;
        left: 45%;
        top: -25%;
      }
    }

    .iconfont {
      color: $primary-color;
      animation: colorChange 2s infinite linear;
      font-size: 12px;
    }
  }
}
@keyframes colorChange {
  0% {
    color: $primary-color;
  }

  50% {
    color: greenyellow;
  }

  100% {
    color: $primary-color;
  }
}

@keyframes chargingChange {
  0% {
    background-color: #171717;
  }

  50% {
    background-color: $primary-color;
  }

  100% {
    background-color: #171717;
  }
}
</style>
